import api from '../api';

function omitUserPassword(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    const body = { ...payload };
    delete body.password;
    delete body.repassword;
    delete body.rePassword;
    return body;
}

export default {
    async getDataUser(userId, accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await api.get(`/user/${userId}`, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            throw error;
        }
    },

    async getAllUser(accessToken, page){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/user?page=${page}&size=100`, {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            // throw error;
        }
    },
    async getAllUserWithPurchase(accessToken, page = 0, perPage = 10, payload){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/user/order?page=${page}&size=${perPage}`, payload, {
                method: 'POST',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            // throw error;
        }
    },

    async getAllUserExport(accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/user?page=1&size=99999`, {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            // throw error;
        }
    },

    async CreateUser(accessToken, userData){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/user', userData, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao obter dados da criação do usuário:', error);
            throw error;
        }
    },
    async EditUser(payload , accessToken, id){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/user/${id}`, omitUserPassword(payload), {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao editar usuário:', error);
            throw error;
        }
    },
    async changePassword(payload , accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/user/change-password`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            throw error;
        }
    },
    async getUserStats(accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/report/userstats`, { 
                headers ,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados das estatísticas do usuário:', error);
            throw error;
        }
    },
    async getUserByName(accessToken, payload){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/user/name?size=100`, payload, { 
                headers ,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter usuário pelo nome:', error);
            throw error;
        }
    },
    async getUserId(id, accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
                const response = await api.get(`/user/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter usuário:', error);
            throw error;
        }
    },
    async resetPassword(accessToken, id) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.post(`/user/restart-password/${id}`, {}, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao enviar email de reset de senha:', error);
            throw error;
        }
    },
    async activateAccount( payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.post(`ecommerce/definir-senha`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ativar conta:', error);
            throw error;
        }
    }
}